export const HOSTING_CONFIG = {
  ANDROID_DOMAIN: 'toonaiapp.com',
  IOS_DOMAIN: 'photoaiapps.com',
  ANDROID_APP_NAME: 'ToonAI',
  IOS_APP_NAME: 'PhotoAI',
  ANDROID_CAMPAIGN_LINK_ID: 'cartoon.anime.maker.ai.avatar.image.generator.app',
  ANDROID_CAMPAIGN_LINK_SOURCE: 'web',
  ANDROID_CAMPAIGN_LINK_MEDIUM: 'social',
  ANDROID_CAMPAIGN_LINK_CAMPAIGN: 'get_web',
  IOS_CAMPAIGN_LINK_ID: '6744649843',
  IOS_CAMPAIGN_LINK_PT: '122501225',
  IOS_CAMPAIGN_LINK_CT: 'get_web',
  IOS_CAMPAIGN_LINK_MT: '8',
}
